export default "__VITE_PUBLIC_ASSET__a7705563__"